<div class="relative">
    <div #echarts echarts [options]="options" class="demo-chart"></div>
    <div #echarts2 echarts [options]="options2" theme="macarons" class="hidden"></div>

    <app-chart-paginator [currentPage]="currentPage" [totalPages]="totalPages" (updateActionEmit)="updateChartData($event)"></app-chart-paginator>
</div>